import { ColorDef, GameColor, PrimaryColor } from "./types";
import { DOUBLE_TAP_THRESHOLD_MS } from "./config";
import { nextColor } from "./rules/colorMixing";

export const COLORS: Record<GameColor, ColorDef> = {
    red: { name: "RED", rgb: [245, 55, 75] },
    blue: { name: "BLUE", rgb: [45, 140, 255] },
    yellow: { name: "YELLOW", rgb: [255, 215, 30] },
    purple: { name: "PURPLE", rgb: [180, 60, 255] },
    green: { name: "GREEN", rgb: [45, 220, 105] },
    orange: { name: "ORANGE", rgb: [255, 135, 25] },
};

/** Tracks the player's active colour and detects double-taps on the colour buttons. */
export class ColorController {
    private activeColor: GameColor;
    private lastPress: { color: PrimaryColor; timeMs: number } | null = null;

    constructor(initialColor: GameColor) {
        this.activeColor = initialColor;
    }

    public getActiveColor(): GameColor {
        return this.activeColor;
    }

    public press(color: PrimaryColor, timeMs: number = performance.now()): GameColor {
        const isDoubleTap =
            this.lastPress?.color === color && timeMs - this.lastPress.timeMs <= DOUBLE_TAP_THRESHOLD_MS;
        this.lastPress = { color, timeMs };
        this.activeColor = nextColor(this.activeColor, color, isDoubleTap);
        return this.activeColor;
    }
}
